import styled from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import { Typography } from '../../../ui/Typography';
import { ItemList } from '../../../ui/ItemCard/styled';
import { tagStyles } from '../../../ui/Typography/styles';

export const SimilarAdsContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background.tertiary};

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    background-color: ${({ theme }) => theme.colors.background.primary};
  }
`;

export const SimilarAdsContent = styled.div`
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding-top: 10px;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    padding: 0 40px;
  }

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    padding-top: 20px;
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    padding: 20px 20px 0;
  }
`;

export const SimilarAdsTitle = styled(Typography)`
  margin-bottom: 15px;
  display: block;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    margin-bottom: 20px;
  }

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    margin-bottom: 35px;
    ${tagStyles.header_bold}
  }
`;

export const SimilarAdsList = styled(ItemList)`
  > div {
    padding-right: 0;
  }
`;
